import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  reviewScreenCloseWindowText: {
    id: "funding-application: review page close your window",
    defaultMessage: "You can now close this window.",
  },
  reviewScreenAirOnHoldHeading: {
    id: "funding-application: review page app on hold new title",
    defaultMessage: "We need some additional information",
  },
  reviewScreenYourApplicationStatusHeading: {
    id: "funding-application: review page application status heading",
    defaultMessage: "Your application status",
  },
  reviewScreenApplicationOverviewLinkText: {
    id: "funding-application: application submitted overview link text",
    defaultMessage: "overview",
  },
  reviewScreenApplicationSubmittedTimeSince: {
    id: "funding-application: application submitted time since",
    defaultMessage: "Submitted {elapsedTime} ago",
  },
  reviewScreenDescriptionSubsequentFunding: {
    id: "funding-application: review screen description for subsequent funding",
    defaultMessage:
      "We are now reviewing your application. We will email you with updates or any requests for additional information. You can check back here to see the status of your application.",
  },
  reviewScreenHeading: {
    id: "funding-application: review screen page heading",
    defaultMessage: "Thanks, that's everything for now",
  },
  reviewScreenEmailVerificationRequiredTitle: {
    id: "funding-application: review page email verification required title",
    defaultMessage: "One last thing, please verify your email address",
  },
});
